import SkusRepository from 'client-sdk/src/Repository/skus-repository';
import ParcelItemsRepository from 'client-sdk/src/Repository/parcel-items-repository';
import WarehouseRepository from 'client-sdk/src/Repository/warehouses-repository';
import {takeLatest, put} from 'redux-saga/effects';
import {
  GET_WAREHOUSES_FAILED,
  GET_WAREHOUSES_SUCCESS,
  GET_WAREHOUSES,
  UPDATE_WAREHOUSES_FAILED,
  UPDATE_WAREHOUSES_SUCCESS,
  UPDATE_WAREHOUSES,
  CREATE_WAREHOUSES_FAILED,
  CREATE_WAREHOUSES_SUCCESS,
  CREATE_WAREHOUSES,
  GET_WAREHOUSES_INVENTORY_SUCCESS,
  GET_WAREHOUSES_INVENTORY_FAILED,
  UPDATE_WAREHOUSES_STATUS,
  UPDATE_WAREHOUSES_STATUS_SUCCESS,
  UPDATE_WAREHOUSES_STATUS_FAILED,
  GET_WAREHOUSE_WITH_ID,
  GET_WAREHOUSE_WITH_ID_SUCCESS,
  GET_WAREHOUSE_WITH_ID_FAILED,
  UPDATE_WAREHOUSE_ADMIN,
  UPDATE_WAREHOUSE_ADMIN_SUCCESS,
  UPDATE_WAREHOUSE_ADMIN_FAILED,
  GET_WAREHOUSE_CHILDREN,
  GET_WAREHOUSE_CHILDREN_SUCCESS,
  GET_WAREHOUSE_CHILDREN_FAILED,
  GET_SKUS_INVENTORY,
  GET_SKUS_INVENTORY_SUCCESS,
  GET_SKUS_INVENTORY_FAILED,
  GET_WAREHOUSES_INVENTORY_BY_ID,
  GET_WAREHOUSES_INVENTORY_BY_ID_SUCCESS,
  GET_WAREHOUSES_INVENTORY_BY_ID_FAILED,
  GET_PARCELS_ITEMS,
  GET_PARCELS_ITEMS_SUCCESS,
  GET_PARCELS_ITEMS_FAILED,
  GET_SKUS_INVENTORY_BY_ID,
  GET_SKUS_INVENTORY_BY_ID_SUCCESS,
  GET_SKUS_INVENTORY_BY_ID_FAILED,
  GET_SKUS_INVENTORY_FINALIZED_SUM_SUCCESS,
  GET_SKUS_INVENTORY_FINALIZED_SUM_FAILED,
  GET_SKUS_INVENTORY_FINALIZED_SUM,
  GET_SKUS_INVENTORY_NOT_FINALIZED_SUM_SUCCESS,
  GET_SKUS_INVENTORY_NOT_FINALIZED_SUM_FAILED,
  GET_SKUS_INVENTORY_NOT_FINALIZED_SUM,
  GET_WAREHOUSE_OPERATORS_BY_ID,
  GET_WAREHOUSE_OPERATORS_BY_ID_SUCCESS,
  GET_WAREHOUSE_OPERATORS_BY_ID_FAILED,
} from './constants';
import {GET_USERS} from '../users/constants';
import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotfication';

export function* getWarehouses(actions: any): unknown {
  try {
    const {response, count} = yield WarehouseRepository.getWarehouses(actions);
    yield put({
      type: GET_WAREHOUSES_SUCCESS,
      data: response.data,
      count: count.data,
    });
  } catch (error) {
    yield put({
      type: GET_WAREHOUSES_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getParcelsItems(actions: any): unknown {
  try {
    const {response, count} = yield ParcelItemsRepository.getParcelsItems(
      actions
    );

    yield put({
      type: GET_PARCELS_ITEMS_SUCCESS,
      data: response.data?.content,
    });
  } catch (error) {
    yield put({
      type: GET_PARCELS_ITEMS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* updateWarehouses(actions: any): unknown {
  const {pagination} = actions.payload;
  try {
    yield WarehouseRepository.updateWarehouses(actions);
    yield put({
      type: UPDATE_WAREHOUSES_SUCCESS,
    });
    yield put({
      type: GET_WAREHOUSES,
      payload: {
        ...pagination,
      },
    });
  } catch (error) {
    yield put({
      type: UPDATE_WAREHOUSES_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* createWarehouse(actions: any): unknown {
  const {pagination, id} = actions.payload;
  try {
    yield WarehouseRepository.createWarehouse(actions);
    yield put({
      type: CREATE_WAREHOUSES_SUCCESS,
    });
    yield put({
      type: GET_WAREHOUSES,
      payload: {...pagination, partnerId: {equals: id}},
    });

    handleNotfication('انبار با موفقیت اضافه شد', 'success');
  } catch (error) {
    yield put({
      type: CREATE_WAREHOUSES_FAILED,
      error: error.message,
    });
    handleNotfication('اضافه کردن انبار با خطا مواجه شد', 'error');
    handleError(error.response);
  }
}

export function* getWarehousesInventory(actions: any): unknown {
  try {
    const response = yield WarehouseRepository.getWarehouseInventory(actions);
    yield put({
      type: GET_WAREHOUSES_INVENTORY_SUCCESS,
      data: response.data.content,
      count: response.data.totalElements,
    });
  } catch (error) {
    yield put({
      type: GET_WAREHOUSES_INVENTORY_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getWarehousesInventoryById(actions: any): unknown {
  try {
    const response = yield WarehouseRepository.getWarehousesInventoryById(
      actions
    );

    yield put({
      type: GET_WAREHOUSES_INVENTORY_BY_ID_SUCCESS,
      data: response.data.content,
      count: response.data.totalElements,
    });
  } catch (error) {
    yield put({
      type: GET_WAREHOUSES_INVENTORY_BY_ID_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getWarehouseOperatorsById(actions: any): any {
  try {
    const response = yield WarehouseRepository.getWarehouseOperatorsById(
      actions
    );

    yield put({
      type: GET_WAREHOUSE_OPERATORS_BY_ID_SUCCESS,
      data: response.data.content,
      count: response.data.totalElements,
    });
  } catch (error) {
    yield put({
      type: GET_WAREHOUSE_OPERATORS_BY_ID_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getSkusInventory(actions: any): unknown {
  try {
    const response = yield SkusRepository.getSkusInventory(actions);

    yield put({
      type: GET_SKUS_INVENTORY_SUCCESS,
      data: response.data.content,
      count: response.data.totalElements,
    });
  } catch (error) {
    yield put({
      type: GET_SKUS_INVENTORY_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getSkusInventoryFinalizedSum(actions: any): any {
  try {
    const response = yield SkusRepository.getSkusInventoryFinalizedSum(actions);

    yield put({
      type: GET_SKUS_INVENTORY_FINALIZED_SUM_SUCCESS,
      data: response.data.content,
      count: response.data.totalElements,
    });
  } catch (error) {
    yield put({
      type: GET_SKUS_INVENTORY_FINALIZED_SUM_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getSkusInventoryNotFinalizedSum(actions: any): any {
  try {
    const response = yield SkusRepository.getSkusInventoryNotFinalizedSum(
      actions
    );

    yield put({
      type: GET_SKUS_INVENTORY_NOT_FINALIZED_SUM_SUCCESS,
      data: response.data.content,
      count: response.data.totalElements,
    });
  } catch (error) {
    yield put({
      type: GET_SKUS_INVENTORY_NOT_FINALIZED_SUM_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getSkusInventoryWithId(actions: any): unknown {
  try {
    const response = yield SkusRepository.getSkusInventoryWithId(actions);

    yield put({
      type: GET_SKUS_INVENTORY_BY_ID_SUCCESS,
      data: response.data.content,
      count: response.data.totalElements,
    });
  } catch (error) {
    yield put({
      type: GET_SKUS_INVENTORY_BY_ID_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* updateWarehouseStatus(actions: any): unknown {
  const {pagination, callback} = actions.payload;
  try {
    yield WarehouseRepository.updateWarehouseStatus(actions);
    yield put({
      type: UPDATE_WAREHOUSES_STATUS_SUCCESS,
    });
    yield put({
      type: GET_WAREHOUSES,
      payload: {...pagination, sort: 'created,desc'},
    });
    callback && callback();
  } catch (error) {
    yield put({
      type: UPDATE_WAREHOUSES_STATUS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getWarehouseWithId(actions: any): unknown {
  try {
    const response = yield WarehouseRepository.getWarehouseWithId(actions);
    yield put({
      type: GET_WAREHOUSE_WITH_ID_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_WAREHOUSE_WITH_ID_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getWarehouseChildren(actions: any): unknown {
  try {
    const response = yield WarehouseRepository.getWarehouseChildren(actions);
    yield put({
      type: GET_WAREHOUSE_CHILDREN_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_WAREHOUSE_CHILDREN_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* updateWarehouseAdmin(actions: any): unknown {
  const {pagination} = actions.payload;
  try {
    yield WarehouseRepository.updateWarehouseAdmin(actions);
    yield put({
      type: UPDATE_WAREHOUSE_ADMIN_SUCCESS,
    });

    yield put({
      type: GET_USERS,
      payload: {...pagination},
    });
    handleNotfication('کاربر انبار با موفقیت ویرایش شد', 'success');
  } catch (error) {
    yield put({
      type: UPDATE_WAREHOUSE_ADMIN_FAILED,
      error: error.message,
    });
    handleError(error.response);
    handleNotfication('ویرایش کاربر انبار با خطا مواجه شد', 'error');
  }
}

export default function* warehouseSaga() {
  yield takeLatest(GET_WAREHOUSES, getWarehouses);
  yield takeLatest(UPDATE_WAREHOUSES, updateWarehouses);
  yield takeLatest(CREATE_WAREHOUSES, createWarehouse);
  yield takeLatest(GET_WAREHOUSE_OPERATORS_BY_ID, getWarehouseOperatorsById);
  yield takeLatest(UPDATE_WAREHOUSES_STATUS, updateWarehouseStatus);
  yield takeLatest(UPDATE_WAREHOUSE_ADMIN, updateWarehouseAdmin);
  yield takeLatest(GET_WAREHOUSE_WITH_ID, getWarehouseWithId);
  yield takeLatest(GET_WAREHOUSE_CHILDREN, getWarehouseChildren);
  yield takeLatest(GET_SKUS_INVENTORY, getSkusInventory);
  yield takeLatest(
    GET_SKUS_INVENTORY_FINALIZED_SUM,
    getSkusInventoryFinalizedSum
  );
  yield takeLatest(
    GET_SKUS_INVENTORY_NOT_FINALIZED_SUM,
    getSkusInventoryNotFinalizedSum
  );
  yield takeLatest(GET_WAREHOUSES_INVENTORY_BY_ID, getWarehousesInventoryById);
  yield takeLatest(GET_PARCELS_ITEMS, getParcelsItems);
  yield takeLatest(GET_SKUS_INVENTORY_BY_ID, getSkusInventoryWithId);
}
